import React from "react";
import banner4 from "../assets/banner4.jpg"; // reuse banner4 or replace with a relevant image

export default function OrganisationalChangeSupport() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Organisational Change Support</h2>
        <p className="text-muted small">
          Assisting organisations through restructuring and operational transitions.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner4} 
          alt="Organisational Change Support" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group helps organisations navigate change effectively by providing 
          support during restructuring, operational adjustments, and strategic transitions. 
          Our services include change planning, process redesign, and staff engagement, 
          ensuring smooth adaptation while maintaining performance and continuity. 
          We combine long-standing experience with practical tools to deliver sustainable results.
        </p>
      </div>

    </section>
  );
}
